import React from 'react'
import {
  Button,
} from 'semantic-ui-react'
import {
  NavLink,
} from 'react-router-dom'
import toClass from './toClass.js'

const CNavLink = toClass(NavLink);

const SelectionButtonGroup = ({id}) => (
  <Button.Group floated='right'>
    <Button color='orange' floated='right' as={CNavLink} exact to={'/selection/'+id}>View</Button>
    <Button color='orange' floated='right' as={CNavLink} to={'/selection/'+id+'/settings'}>Settings</Button>
    <Button color='orange' floated='right' as={CNavLink} to={'/selection/'+id+'/export'}>Export</Button>
  </Button.Group>
)

export default SelectionButtonGroup